export var LOCALE;
(function (LOCALE) {
    LOCALE["EN"] = "en";
    LOCALE["CS"] = "cs";
})(LOCALE || (LOCALE = {}));
export const PLACEHOLDERS = {
    en: 'm/d/yyyy',
    cs: 'd.m.rrrr',
};
//# sourceMappingURL=constants.js.map